/*
 * Update Google Tag Manager’s consent state. After a user grants consent,
 * persist their choice and call the update command as soon as possible on
 * subsequent pages.
 */
export const updateConsent = () => {
  const googleTagManagerId = process.env.GATSBY_GOOGLE_TAG_MANAGER_ID

  if (!googleTagManagerId) {
    return
  }

  if (!window.gtag) {
    return
  }

  window.gtag("consent", "default", {
    ad_storage: "granted",
    analytics_storage: "granted",
    personalization_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
  })

  window.gtag("event", "consentGranted")
}
